<mat-card>
    <mat-card-content class="stars-content">
        <!-- <div class="saldo-rating-icon"></div> -->
        <!-- <img src="../../../../../assets/landing-page/estrellasgoogle.png" width="100" alt="Calificación 5"> -->
        <div class="stars-row">
            <ng-container *ngFor="let i of [1, 2, 3, 4, 5]">
                <div class="star-container">
                    <mat-icon>star_24dp</mat-icon>
                </div>
            </ng-container>
        </div>
    </mat-card-content>
    <mat-card-content>
        <mat-card-title><b>{{title}}</b></mat-card-title>
        <p>{{content}}</p>
    </mat-card-content>
    <mat-card-content class="container-info-user">
        <div class="image-container">
            <picture>
                <source srcset="{{image}}.webp" type="image/webp" />
                <img width="73" height="73" srcset="" src="{{image}}.jpg" alt="{{ alt }}" />
            </picture>
        </div>
        <mat-card-subtitle>{{name}}</mat-card-subtitle>
        <!-- Ver resolucion de trustpilot para borrar o volver a agregarlo -->
        <a target="_blank" href="{{link}}" class="material-icons-outlined">
            open_in_new
        </a>
    </mat-card-content>
</mat-card>